import React, { useState } from 'react'
import styles from './styles.module.css'

function Skus ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <section className={styles?.skusContainer}>
      <h2 className={styles?.skusTitle}>Skus</h2>

      {record?.skus?.length === 0 ? (
        <p className={styles?.noSkus}>N/A</p>
      ) : (
        <ul className={styles?.listSkus}>
          {record?.skus
            ?.slice(0, isExpanded ? record?.skus?.length : 3)
            ?.map((sku, index) => (
              <li key={index} className={styles?.skusContainerItem}>
                <span className={styles?.skusType}>Value</span>
                <span className={styles?.skusValue}>{sku?.value || 'N/A'}</span>
              </li>
            ))}
        </ul>
      )}

      {record?.skus?.length > 3 && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={styles?.expandButtonSkus}
          type='button'
        >
          {isExpanded ? 'Show Less' : `Expand All (${record?.skus?.length})`}
        </button>
      )}
    </section>
  )
}

export default Skus
